export function CrossIcon({ mainClassName, strokeClassName }) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 24 24"
    >
      <path
        d="M16 8l-4 4 4 4M8 8l4 4-4 4"
        stroke="#505A72"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={strokeClassName}
      />
    </svg>
  );
}